import amountpaid from './amount-paid';
import assignedto from './assigned-to';
import carrier from './carrier';
import city from './city';
import closeddate from './closed-date';
import company from './company';
import country from './country';
import createddate from './created-date';
import datepaid from './date-paid';
import deliverynotification from './delivery-notification';
import isDomestic from './destination';
import insurance from './insurance';
import insurancefee from './insurance-fee';
import labelprinted from './label-printed';
import marketplacenotification from './marketplace-notification';
import orderdate from './order-date';
import ordernumber from './order-number';
import packagetype from './package-type';
import packingslip from './packing-slip';
import postalcode from './postal-code';
import provider from './provider';
import quantity from './quantity';
import rate from './rate';
import recipientname from './recipient-name';
import service from './service';
import rateShopper from './rate-shopper';
import refundStatus from './refund-status';
import voidType from './void-type';
import shipdate from './ship-date';
import shipfrom from './ship-from';
import shipmentnotification from './shipment-notification';
import shipmentnumber from './shipment-number';
import shippingaccount from './shipping-account';
import shippingpaid from './shipping-paid';
import source from './source';
import state from './state';
import store from './store';
import taxpaid from './tax-paid';
import { pendingCustomsDocumentsOption as pendingCustomsDocuments } from './pending-customs-documents';
import { serialNumber as serialnumber } from './serial-number';

export default [
  amountpaid,
  assignedto,
  carrier,
  city,
  closeddate,
  company,
  country,
  createddate,
  datepaid,
  deliverynotification,
  isDomestic,
  insurancefee,
  insurance,
  labelprinted,
  marketplacenotification,
  orderdate,
  ordernumber,
  packagetype,
  packingslip,
  postalcode,
  provider,
  quantity,
  rate,
  rateShopper,
  recipientname,
  refundStatus,
  serialnumber,
  service,
  shipdate,
  shipfrom,
  shipmentnotification,
  shipmentnumber,
  shippingaccount,
  shippingpaid,
  source,
  state,
  store,
  taxpaid,
  voidType,
  pendingCustomsDocuments,
];
